<template>
  <div class="top-bar--right">
<!--    <b-button v-if="showStartNextJobButton"-->
<!--              variant="-primary"-->
<!--              size="-small"-->
<!--              :disabled="disableStartNextJobButton"-->
<!--              @click="handleStartNextJob">-->
<!--      Start next job-->
<!--    </b-button>-->
    <b-button :class="{'btn--disabled': !activeLiveView, 'btn--secondary': activeLiveView}"
              size="-small"
              v-if="showLiveView"
              @click="openLiveView = true"
              :disabled="!activeLiveView">
      <svg class="icon icon--video">
        <use xlink:href="#video"></use>
      </svg>
    </b-button>
    <b-dropdown variant="-ternary btn--dots no--arr btn--outline" size="-small" text="⋮" right v-if="showTools" @shown="$emit('menuOpened')" @hidden="$emit('menuClosed')">
      <b-dropdown-item-button v-if="canShare" @click="share">
        <font-awesome-icon icon="share-alt" fixed-width /> {{$t('printers.item.share')}}
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="showPrinterSettings" @click="handleOpenPrinterSettings">
        <font-awesome-icon icon="cogs" fixed-width /> {{$t('printers.item.printerSettings')}}
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="!isIndustrial" @click="$emit('openPrinterLog')">
        <font-awesome-icon icon="scroll" fixed-width /> {{$t('printers.item.printerLog')}}
      </b-dropdown-item-button>
      <!--<b-dropdown-item-button v-if="canPrint(printer.printer_ownership_id)">
        <font-awesome-icon icon="terminal" fixed-width /> Console
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="canPrint(printer.printer_ownership_id)">
        <font-awesome-icon icon="gamepad" fixed-width /> Joystick
      </b-dropdown-item-button>-->
      <b-dropdown-item-button v-if="showSortJobs" @click="handleToggleJobSorting">
        <font-awesome-icon icon="sort" fixed-width /> <span v-if="!jobSorting">{{$t('printers.item.jobSorting')}}</span><span class="text-danger" v-else>{{$t('printers.item.finishJobSorting')}}</span>
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="showMoveAllJobs" @click="handleMoveAllJobs">
        <font-awesome-icon icon="paper-plane" fixed-width /> {{$t('printers.item.moveAllJobs')}}
      </b-dropdown-item-button>
      <!--<b-dropdown-item-button v-if="showUnsetFromWorkgroup">
        <font-awesome-icon icon="times" fixed-width /> Unset from workgroups
      </b-dropdown-item-button>
      <b-dropdown-item-button>
        <font-awesome-icon icon="life-ring" fixed-width /> Get support
      </b-dropdown-item-button>-->
    </b-dropdown>
    <b-modal v-model="sharingShow" size="lg" hide-footer>
      <printer-sharing :printer-id="printer.printer_id"></printer-sharing>
    </b-modal>
    <b-modal v-model="settingsShow" modal-class="modal--edit modal--printer-settings">
      <printer-settings :printer="printer" ref="printerSettingsComponent" @close="settingsShow = false"></printer-settings>
      <template v-slot:modal-footer="{ cancel, ok }">
        <div class="modal__footer--left">
          <b-button variant="-gray" @click="cancel()">
            {{$t('printers.item.buttons.closeWithoutSaving')}}
          </b-button>
        </div>
        <div class="modal__footer--right">
          <b-button variant="-primary" @click="handleSavePrinterSettings(ok)">
            {{$t('printers.item.buttons.saveChanges')}}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="openLiveView" size="lg" hide-footer>
      <camera-live-view :printer-id="printer.printer_id" :webcam-id="printer.webcam_id"></camera-live-view>
    </b-modal>

    <b-modal ref="movePopup" v-model="openMoveAllJobs" modal-class="modal--clear" size="lg" hide-footer>
      <choose-printer-for-action :jobs="jobs"
                                 :printer-id="printer.printer_id"
                                 :printer-type-id="printer.printer_type_id"
                                 :only-industrial="printer.virtual === 't'"
                                 action="move"
                                 @close="handleCloseMovePopup">
      </choose-printer-for-action>
    </b-modal>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import PrinterMixin from "@/mixins/printer";
  import PrinterSharing from "../modal/SharePrinter";
  import PrinterSettings from "../modal/PrinterSettings";
  import CameraLiveView from "../camera/CameraLiveView";
  import ChoosePrinterForAction from "../modal/ChoosePrinterForAction";

  export default {
    name: 'printer-action-buttons',
    props: ['printer', 'jobSorting', 'jobsInQueueCount'],
    mixins: [PrinterMixin],
    components: {
      PrinterSharing,
      PrinterSettings,
      CameraLiveView,
      ChoosePrinterForAction
    },
    data() {
      return {
        sharingShow: false,
        settingsShow: false,
        openLiveView: false,
        openMoveAllJobs: false,
        startNextJobProcess: false
      }
    },
    computed: {
      ...mapGetters(['getPrintSettings', 'getJobsByPrinter', 'isOrgAdmin']),

      showLiveView() {
        return this.printer.camera_type && this.printer.camera_type !== 'Disable camera';
      },
      activeLiveView() {
        return this.printer.camera_type !== 'Disable camera' && this.printer.webcam_id > 0;
      },
      canShare() {
        return this.canAccessAsOwner(this.printer.printer_ownership_id);
      },
      showTools() {
        return !this.getPrintSettings.noPrinterSettings ||
          this.canAccessAsOwner(this.printer.printer_ownership_id) ||
          this.canPrint(this.printer.printer_ownership_id);
      },
      showPrinterSettings() {
        return !this.getPrintSettings.noPrinterSettings || this.canAccessAsOwner(this.printer.printer_ownership_id); //TODO: check advanced users with org settings
      },
      showUnsetFromWorkgroup() {
        return this.isOrgAdmin;
      },
      showMoveAllJobs() {
        return this.jobsInQueue.length > 0 && this.canPrint(this.printer.printer_ownership_id)
      },
      showSortJobs() {
        return this.jobsInQueue.length > 1 && this.canPrint(this.printer.printer_ownership_id)
      },
      jobs() {
        return this.getJobsByPrinter(this.printer.printer_id);
      },
      jobsInQueue() {
        return this.jobs.filter(job => job.job_status_id == 11);
      },
      isIndustrial() {
        return this.printer.state === 'Virtual';
      }
    },
    methods: {
      ...mapActions(['startNextJob']),

      share() {
        this.sharingShow = true;
      },
      handleOpenPrinterSettings() {
        this.settingsShow = true;
      },
      handleSavePrinterSettings(ok) {
        this.$refs['printerSettingsComponent'].handleUpdatePrinterSettings();
        ok();
      },
      handleMoveAllJobs() {
        this.openMoveAllJobs = true;
      },
      handleCloseMovePopup() {
        this.$refs['movePopup'].hide();
      },
      handleToggleJobSorting() {
        this.$emit('toggleJobSorting');
      }
    }
  }
</script>
